import queryString from 'query-string';

import {
	loadFromSessionStorage,
	saveToSessionStorage,
	ssKeys,
} from '~features/storage';

import { allowedMarkers } from './markerKeys';

//Logic copied from landing
//the idea is to gather markers from all available sources on site entry
//then markers should be sent during registration if occurs
class Markers {
	private allowedMarkers = allowedMarkers;
	private readonly hash: Record<string, unknown> = {};
	private readonly search: Record<string, unknown> = {};
	private readonly session: Record<string, string> = {};
	private responseMarkers: Record<string, unknown> = {};
	private readonly pathWithMarkers: string | undefined;

	constructor() {
		if (typeof window !== 'undefined') {
			this.hash = queryString.parse(window.location.hash);
			this.search = queryString.parse(window.location.search);
			this.session = loadFromSessionStorage(ssKeys.MARKERS, {}) as Record<
				string,
				string
			>;

			this.pathWithMarkers = document.location.href;
			this.init();
		}
	}

	init = () => {
		if (Object.keys(this.session).length > 0) {
			this.responseMarkers = this.session;
			return;
		}
		this.allowedMarkers.forEach((marker) => {
			if (this.hash[marker]) {
				this.responseMarkers[marker] = this.hash[marker];
				return;
			}
			if (this.search[marker]) {
				this.responseMarkers[marker] = this.search[marker];
				if (Array.isArray(this.search[marker])) {
					this.responseMarkers[marker] = this.search[marker]?.[0];
				}
				return;
			}
			if (document[marker as keyof Document] && !this.responseMarkers[marker]) {
				this.responseMarkers[marker] = document[marker as keyof Document];
			}
		});
		return saveToSessionStorage(ssKeys.MARKERS, this.responseMarkers);
	};

	getMarkersRegistration = () => {
		this.init();
		return {
			...this.responseMarkers,
			referrer:
				this.responseMarkers.referrer ||
				document.referrer ||
				window.location.href,
			emguid: 0,
			tracker: null,
		} as unknown as Record<string, string>;
	};

	getMarkersAnnals = () => {
		return {
			link: document.location.origin + document.location.pathname,
			link_full: this.getFullPathWithMarkers(),
			AFID: this.responseMarkers['afid'],
			StageName: this.responseMarkers['utm_source'],
			Campaign: this.responseMarkers['utm_campaign'],
		};
	};

	clearMarkers = () => {
		return saveToSessionStorage(ssKeys.MARKERS, {});
	};

	getFullPathWithMarkers = () => {
		return this.pathWithMarkers;
	};
}

export const MarkersService = new Markers();
